export const floorToZero = (number: number): number => Math.max(number, 0);
